import type { ExtractPropTypes } from 'vue'
import { linkProps as elLinkProps } from 'element-plus'

export const linkProps = {
  ...elLinkProps,
  content: {
    type: String,
  },
  type: {
    ...elLinkProps.type,
    default: 'primary',
  },
  underline: {
    ...elLinkProps.underline,
    default: 'never',
  },
} as const
export type LinkProps = ExtractPropTypes<typeof linkProps>
